import { render, staticRenderFns } from "./AgentDeliveryMethod.vue?vue&type=template&id=72d8ff35&"
import script from "./AgentDeliveryMethod.vue?vue&type=script&lang=js&"
export * from "./AgentDeliveryMethod.vue?vue&type=script&lang=js&"
import style0 from "./AgentDeliveryMethod.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports